var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ai-check-container" },
    [
      _vm._m(0),
      _vm.isInitialLoading
        ? _c(
            "div",
            {
              staticClass:
                "glass-card loading-container flex flex-column justify-center align-center",
            },
            [
              _c("i", {
                staticClass: "el-icon-loading",
                staticStyle: {
                  "font-size": "40px",
                  color: "#3b82f6",
                  "margin-bottom": "12px",
                },
              }),
              _c(
                "p",
                { staticStyle: { color: "#64748b", "font-weight": "600" } },
                [_vm._v("Đang tải cấu hình Webhook...")]
              ),
            ]
          )
        : _c(
            "div",
            { staticClass: "glass-card panel-container" },
            [
              _c(
                "el-tabs",
                {
                  staticClass: "modern-tabs",
                  attrs: { type: "card" },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Cấu hình Webhook", name: "config" } },
                    [
                      _c("div", { staticClass: "tab-inner-content" }, [
                        _c(
                          "div",
                          { staticClass: "hint-panel blue-hint mb-4" },
                          [
                            _c("div", { staticClass: "hint-title" }, [
                              _c("i", { staticClass: "el-icon-info" }),
                              _vm._v(
                                " Cơ chế hoạt động của Webhook\n            "
                              ),
                            ]),
                            _c("ul", { staticClass: "hint-list" }, [
                              _c("li", [
                                _vm._v(
                                  "Webhook gửi dữ liệu sự kiện phát sinh từ cổng Bank Hub về hệ thống máy chủ của bạn một cách chủ động."
                                ),
                              ]),
                              _c("li", [
                                _c("strong", [_vm._v("Webhook URL:")]),
                                _vm._v(
                                  " Đường dẫn đích nhận thông tin HTTP POST request (yêu cầu chuẩn HTTPS)."
                                ),
                              ]),
                              _c("li", [
                                _c("strong", [_vm._v("Secret Key:")]),
                                _vm._v(
                                  " Khóa bí mật dùng để tạo chữ ký mã hóa (gửi qua Header "
                                ),
                                _c("code", [_vm._v("X-Secret-Key")]),
                                _vm._v(")."),
                              ]),
                              _c("li", [
                                _c("strong", [_vm._v("Active:")]),
                                _vm._v(
                                  " Bật/Tắt hoạt động của Webhook. Khi tắt, hệ thống sẽ tạm ngừng gửi các sự kiện."
                                ),
                              ]),
                            ]),
                          ]
                        ),
                        _vm.webhook
                          ? _c(
                              "div",
                              { staticClass: "webhook-status-card mb-4" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "status-header" },
                                  [
                                    _c(
                                      "h3",
                                      { staticClass: "section-title mb-0" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-odometer",
                                        }),
                                        _vm._v(" Thông số kết nối hiện tại"),
                                      ]
                                    ),
                                    _c(
                                      "el-tag",
                                      {
                                        staticClass: "status-tag",
                                        attrs: {
                                          type:
                                            _vm.webhook.active === 1
                                              ? "success"
                                              : "danger",
                                          effect: "dark",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.webhook.active === 1
                                                ? "Đang hoạt động"
                                                : "Tạm dừng"
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "status-grid-info mt-3" },
                                  [
                                    _c("div", { staticClass: "info-item" }, [
                                      _c(
                                        "span",
                                        { staticClass: "info-label" },
                                        [_vm._v("Webhook URL")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "info-val code-font" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.webhook.webhook_url)
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _c("div", { staticClass: "info-item" }, [
                                      _c(
                                        "span",
                                        { staticClass: "info-label" },
                                        [
                                          _vm._v(
                                            "Phương thức bảo mật (Auth Type)"
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "info-val" },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "info",
                                                size: "mini",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.webhook.auth_type)
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c("div", { staticClass: "info-item" }, [
                                      _c(
                                        "span",
                                        { staticClass: "info-label" },
                                        [_vm._v("Khóa bí mật (Secret Key)")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "info-val code-font text-password",
                                        },
                                        [_vm._v("••••••••••••••••••••••••")]
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "registered-events-section mt-4",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "info-label mb-2 block" },
                                      [
                                        _vm._v(
                                          "Các sự kiện đã đăng ký lắng nghe (" +
                                            _vm._s(
                                              _vm.webhook.allow_events
                                                ? _vm.webhook.allow_events
                                                    .length
                                                : 0
                                            ) +
                                            ")"
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "events-tags-container" },
                                      [
                                        _vm.webhook.allow_events &&
                                        _vm.webhook.allow_events.length === 0
                                          ? _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type: "info",
                                                  size: "medium",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Chưa đăng ký sự kiện nào\n                "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._l(
                                          _vm.webhook.allow_events,
                                          function (event, index) {
                                            return _c(
                                              "el-tag",
                                              {
                                                key: index,
                                                staticClass: "event-tag-chip",
                                                attrs: {
                                                  type: "success",
                                                  size: "medium",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(event) +
                                                    "\n                "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "empty-state-card mb-4" },
                              [
                                _c("i", {
                                  staticClass: "el-icon-circle-close",
                                }),
                                _c("p", { staticClass: "empty-text" }, [
                                  _vm._v(
                                    "Chưa có đường dẫn Webhook nào được cấu hình cho Merchant này."
                                  ),
                                ]),
                              ]
                            ),
                        _c(
                          "div",
                          { staticClass: "action-row pt-2" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "gradient-btn-small blue",
                                attrs: {
                                  type: "primary",
                                  icon: "el-icon-edit",
                                },
                                on: { click: _vm.showEditDialog },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.webhook ? "Chỉnh sửa" : "Cấu hình mới"
                                    ) +
                                    " Webhook\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: "Danh mục & Tham chiếu Sự kiện",
                        name: "events",
                      },
                    },
                    [
                      _c("div", { staticClass: "tab-inner-content" }, [
                        _c(
                          "div",
                          { staticClass: "hint-panel orange-hint mb-4" },
                          [
                            _c("div", { staticClass: "hint-title" }, [
                              _c("i", { staticClass: "el-icon-collection" }),
                              _vm._v(
                                " 13 Loại Sự kiện trên hệ thống\n            "
                              ),
                            ]),
                            _c("p", { staticClass: "hint-text mb-0" }, [
                              _vm._v(
                                "Dưới đây là các sự kiện chi tiết mà hệ thống hỗ trợ gửi thông báo Webhook về máy chủ đối soát."
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "event-category-block mb-4" },
                          [
                            _c("h3", { staticClass: "category-title" }, [
                              _c("i", { staticClass: "el-icon-key" }),
                              _vm._v(" Link Token Events (3 sự kiện)"),
                            ]),
                            _c("div", { staticClass: "events-grid" }, [
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("LINK_TOKEN_CREATED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Phát sinh khi có yêu cầu khởi tạo Link Token mới thành công."
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("LINK_TOKEN_REVOKED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Phát sinh khi một Link Token bị hủy bỏ quyền liên kết."
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("LINK_TOKEN_EXPIRED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Phát sinh khi Link Token hết thời gian hiệu lực cho phép."
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "event-category-block mb-4" },
                          [
                            _c("h3", { staticClass: "category-title" }, [
                              _c("i", { staticClass: "el-icon-monitor" }),
                              _vm._v(" Link Session Events (7 sự kiện)"),
                            ]),
                            _c("div", { staticClass: "events-grid" }, [
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("LINK_SESSION_INITIALIZED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Bắt đầu khởi dựng phiên liên kết tài khoản ngân hàng."
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("LINK_SESSION_REINITIALIZED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Khởi dựng lại phiên liên kết ngân hàng từ trạng thái cũ."
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("LINK_SESSION_STATE_CHANGED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Trạng thái xử lý phiên liên kết thay đổi (đang xử lý, chờ OTP...)."
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("LINK_SESSION_COMPLETED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Phiên liên kết hoàn thành và kết nối tài khoản thành công."
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("LINK_SESSION_FAILED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Phiên liên kết tài khoản bị lỗi hoặc thất bại giữa chừng."
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("LINK_SESSION_ABANDONED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Người dùng chủ động từ bỏ/hủy ngang phiên liên kết."
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("LINK_SESSION_EXPIRED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Phiên liên kết quá thời gian phản hồi và tự động đóng."
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "event-category-block mb-4" },
                          [
                            _c("h3", { staticClass: "category-title" }, [
                              _c("i", { staticClass: "el-icon-bank" }),
                              _vm._v(" Bank Account Events (3 sự kiện)"),
                            ]),
                            _c("div", { staticClass: "events-grid" }, [
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("BANK_ACCOUNT_LINKED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Tài khoản ngân hàng đã được liên kết chính thức vào Brand."
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("BANK_ACCOUNT_UNLINKED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Hủy bỏ liên kết tài khoản ngân hàng ra khỏi Brand quản lý."
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "event-card-item" }, [
                                _c("code", { staticClass: "ev-code" }, [
                                  _vm._v("BANK_ACCOUNT_INACTIVATED"),
                                ]),
                                _c("p", { staticClass: "ev-desc" }, [
                                  _vm._v(
                                    "Tài khoản ngân hàng bị hệ thống vô hiệu hóa ngắt kết nối."
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "quick-actions-bar mt-4 pt-3" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "gradient-btn-small green",
                                attrs: {
                                  type: "success",
                                  icon: "el-icon-success",
                                },
                                on: { click: _vm.quickUpdateAll },
                              },
                              [
                                _vm._v(
                                  '\n              Đăng ký nhận tất cả sự kiện (["*"])\n            '
                                ),
                              ]
                            ),
                            _c(
                              "el-button",
                              {
                                staticClass: "cancel-upload-btn",
                                attrs: { icon: "el-icon-circle-close" },
                                on: { click: _vm.quickUpdateNone },
                              },
                              [
                                _vm._v(
                                  "\n              Hủy đăng ký tất cả sự kiện\n            "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.webhook
              ? "CẬP NHẬT CẤU HÌNH WEBHOOK"
              : "THIẾT LẬP WEBHOOK MỚI",
            visible: _vm.dialogEditWebhook,
            width: "780px",
            "custom-class": "modern-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogEditWebhook = $event
            },
            close: _vm.resetWebhookForm,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formWebhook",
              attrs: { model: _vm.formWebhook, "label-position": "top" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label:
                              "Webhook URL nhận thông báo (Bắt buộc HTTPS):",
                            prop: "webhook_url",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder:
                                "https://yourdomain.com/sepay-callback",
                              "prefix-icon": "el-icon-link",
                            },
                            model: {
                              value: _vm.formWebhook.webhook_url,
                              callback: function ($$v) {
                                _vm.$set(_vm.formWebhook, "webhook_url", $$v)
                              },
                              expression: "formWebhook.webhook_url",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Xác thực (Auth Type):",
                            prop: "auth_type",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.formWebhook.auth_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formWebhook, "auth_type", $$v)
                                },
                                expression: "formWebhook.auth_type",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: "SECRET_KEY",
                                  value: "SECRET_KEY",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Khóa bí mật (Secret Key):",
                            prop: "secret_key",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "Nhập khóa bí mật bảo mật header...",
                              "prefix-icon": "el-icon-key",
                              type: "password",
                              "show-password": "",
                            },
                            model: {
                              value: _vm.formWebhook.secret_key,
                              callback: function ($$v) {
                                _vm.$set(_vm.formWebhook, "secret_key", $$v)
                              },
                              expression: "formWebhook.secret_key",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Trạng thái kích hoạt:",
                            prop: "active",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "switch-status-wrapper" },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0,
                                  "active-color": "#10b981",
                                  "inactive-color": "#cbd5e1",
                                },
                                model: {
                                  value: _vm.formWebhook.active,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formWebhook, "active", $$v)
                                  },
                                  expression: "formWebhook.active",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "status-label-switch font-semibold ml-2",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.formWebhook.active === 1
                                          ? "Bật hoạt động"
                                          : "Tạm ngắt"
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Lắng nghe các sự kiện cụ thể:" } },
                [
                  _c(
                    "div",
                    { staticClass: "events-picker-box" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticClass: "mb-3 block font-bold",
                          on: { change: _vm.toggleAllEvents },
                          model: {
                            value: _vm.selectAllEvents,
                            callback: function ($$v) {
                              _vm.selectAllEvents = $$v
                            },
                            expression: "selectAllEvents",
                          },
                        },
                        [
                          _vm._v(
                            '\n            Chọn nhận tất cả các sự kiện (Ký hiệu "*")\n          '
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "checkbox-grid-events",
                          class: { "opacity-50": _vm.selectAllEvents },
                        },
                        _vm._l(_vm.availableEvents, function (event) {
                          return _c(
                            "el-checkbox",
                            {
                              key: event,
                              staticClass: "checkbox-item",
                              attrs: {
                                label: event,
                                disabled: _vm.selectAllEvents,
                              },
                              model: {
                                value: _vm.formWebhook.allow_events,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formWebhook, "allow_events", $$v)
                                },
                                expression: "formWebhook.allow_events",
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(event) +
                                  "\n            "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogEditWebhook = false
                    },
                  },
                },
                [_vm._v("Hủy bỏ")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "gradient-btn-small blue",
                  attrs: { type: "primary", loading: _vm.isSavingWebhook },
                  on: { click: _vm.saveWebhook },
                },
                [_vm._v("\n        Xác nhận lưu cấu hình\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "ai-header-banner" }, [
      _c("div", { staticClass: "banner-overlay" }),
      _c("div", { staticClass: "banner-content" }, [
        _c("div", { staticClass: "banner-left" }, [
          _c("div", { staticClass: "ai-icon-pulse" }, [
            _c("i", { staticClass: "el-icon-connection" }),
          ]),
          _c("div", [
            _c("h1", { staticClass: "banner-title" }, [
              _vm._v("QUẢN LÝ CẤU HÌNH WEBHOOK"),
            ]),
            _c("p", { staticClass: "banner-subtitle" }, [
              _vm._v(
                "Thiết lập kết nối nhận phản hồi sự kiện real-time, khóa xác thực bảo mật và đăng ký lắng nghe sự kiện tài khoản."
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }